import { Link, Image } from "@customTypes/index";
import { Button, Col, Row } from "antd";

interface CardCtaProps {
  className?: string;
  title?: string;
  date?: string;
  description?: string;
  link: Link;
  image: Image;
}

const defaultProps: CardCtaProps = {
  className: "",
  title: "No title found",
  date: "March 24, 2021",
  description: "quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
  link: {
    url: "/",
    name: "Click Me!",
    target: "_self",
  },
  image: {
    src: "https://covrprice.com/wp-content/uploads/2020/02/STL145248.jpg",
    alt: "no image",
  },
};

const CardCta = ({ className, title, date, description, link, image }: CardCtaProps) => {
  return (
    <Row className={`covr-cta-card ${className}`}>
      <Col span={24} className="top">
        <img alt={image.alt} src={image.src} className="responsive-img" />
      </Col>
      <Col span={24} className="bottom">
        {date
          && <a target={link.target} href={link.url}>
            <h4 className="date">{date}</h4>
          </a>
        }
        {title
          && <a target={link.target} href={link.url}>
            <h3 className="title ellipsis line-clamp-1">{title}</h3>
          </a>
        }
        {description
          && <a target={link.target} href={link.url}>
            <p>{description}</p></a>
        }
        {(link.url && link.name)
          && <Button target={link.target} href={link.url} type="primary">
            {link.name}
          </Button>
        }
      </Col>
    </Row>
  );
};

CardCta.defaultProps = defaultProps;

export default CardCta;
